module.exports = __webpack_public_path__ + "img/custom-invest.8fa0f169.svg";